module.exports = __webpack_public_path__ + "static/media/header-1.25e22b7b.png";